import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

import { computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import { Task } from "@/types/v2";
import { useTasksStore } from "@/stores/v2";
import { TasksService } from "@/services/v2/tasks";
import { normalizeRouteParam } from "@/utils/v2/routes"
import { useLoading } from "@/composables/useLoading";

import Filters from "@/components/v2/Dashboard/Tasks/Filters/TasksFilter.vue";
import TaskList from "@/components/v2/Dashboard/Tasks/Lists/TasksList.vue";
import LayoutMain from "@/components/v2/Layouts/LayoutMain.vue";
import LoadingScreen from "@/components/v2/Loaders/LoadingScreen.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardTasksPage',
  setup(__props) {

const { withLoading, isLoading } = useLoading();

const route = useRoute();
const siteKey = normalizeRouteParam(route.params.key)
const tasks = computed(() => useTasksStore().getTasksByActiveFilters)

const init = async () => {
  await withLoading(async () => {
    const tasks: Task[] = await TasksService.getTasksBySiteKey(siteKey);
    if (tasks) useTasksStore().setTasks(tasks);
  })
}

onMounted(init)

return (_ctx: any,_cache: any) => {
  return (_unref(isLoading))
    ? (_openBlock(), _createBlock(LoadingScreen, {
        key: 0,
        text: 'Loading tasks'
      }))
    : (_openBlock(), _createBlock(LayoutMain, { key: 1 }, {
        mainArea: _withCtx(() => [
          _createVNode(Filters, { class: "mb-10" }),
          _createVNode(TaskList, { tasks: tasks.value }, null, 8, ["tasks"])
        ]),
        _: 1
      }))
}
}

})